import React, { useState } from "react";
import Login from "./Component/Login";
import TextExplanation from './Component/TextExplanation'




function App() {
  const [loading, setLoading] = useState(false);
  const onLoading = (val) => {
    setLoading(val);
  };
  return (
    <>
    <div className='loading' style={{ visibility: loading ? 'visible' : 'hidden' }}>
        </div>
    <div dir='rtl' className='container'>
     
      <div className='row mainrow'>
        <div className='col-md-6'><Login onLoading={onLoading}/></div>
        <div className='col-md-6'><TextExplanation /></div>
      </div>
    </div>
</>
  );
}

export default App;
